import React from 'react';
import { compose, withProps } from 'recompose';
import styled, { StylesProps, cx } from '../../../lib/styles';
import holidayStyles from './FeaturedHoliday_styles';
import { Holiday as HolidayModel } from '../../../models/holiday';
import { primaryType } from '../../../lib/holidayUtils';
import Image from '../Image';

const { isArray } = Array;

interface FeaturedHolidayProps {
  featureImage: string;
  featureText?: string;
  type: string;
  holiday: HolidayModel;
  lazy: boolean;
  onClick?: () => any;
}

const FeaturedHoliday = ({
  featureImage,
  featureText,
  //@ts-ignore
  type,
  lazy = true,
  holiday: { 
    title, 
    price_cents, 
    nights, 
    //@ts-ignore
    value_proposition,
    summary,
    link 
  },
  onClick,
  styles,
}: FeaturedHolidayProps & StylesProps<typeof holidayStyles>) => (
  <a
    className={cx('FeaturedHoliday', styles.link)}
    href={link}
    onClick={onClick}
  >
    <div id={`${title.stripSpecialCharacters().replaceSpaces('-').toLowerCase()}`} className={styles.featureContainer}>
      <div className={styles.featureImageContainer}>
        <Image
          alt={title}
          className={cx(styles.featureImage, 'Holiday__image')}
          src={featureImage}
          lazy={lazy}
          aspect={[16, 9]}
          resizeWidth={720}
          resizeFit={'crop'}
        />
        {featureText && <div className={styles.tag}>{featureText}</div>}
      </div>

      <div className={styles.featuretext}>
        {/* <span className={styles.category}>{startCase(type.toLowerCase())}</span> */}
        <h2 className={cx(styles.featuretitle, 'Holiday__title')}>{title}</h2>

        {/* {value_proposition && (
          <div className={styles.highlight}>{value_proposition}</div>
        )} */}

        <div
          className={'content'}
          dangerouslySetInnerHTML={{ __html: summary }}
        />
          
        <span className={styles.subtitle}>
          {nights > 0
            ? `${nights} ${nights === 1 ? 'night' : 'nights'} from`
            : 'from'}
        </span>

        <div className={styles.priceContainer}>
          <span className={styles.featureprice}>
            ${(price_cents / 100).toLocaleString()}
          </span>

          <span className={styles.subtitle}>per person</span>
        </div>
      </div>
    </div>
  </a>
);

const tagText = {
  EXCLUSIVE: 'Exclusive',
  HOT: 'Save now',
};

export default compose(
  withProps(({ holiday: { types, feature_images, tags = [] } }) => ({
    type: primaryType(types) || 'STAY',
    featureText: isArray(tags)
      ? tags
          .map((tag: any) => tag.name)
          .reduce((result, tag) => result || tagText[tag], undefined)
      : undefined,
    featureImage:
      isArray(feature_images) && feature_images.length > 0
        ? feature_images[0].path
        : undefined,
  })),
  styled(holidayStyles)
)(FeaturedHoliday);
